import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IllustrationBackgroundReminders = function IllustrationBackgroundReminders(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 414 358"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "illustration-background-reminders_svg__a",
    width: 414,
    height: 358,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: 'alpha'
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h413.67v358H0z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#illustration-background-reminders_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#F50A4A",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M414 132.632C179.388-190.024-89.105 200.364 214.289 333.117 445.493 434.282 227.312-16.593-34 70.845"
  })));
};